import { render, staticRenderFns } from "./TechServiceMechanic.vue?vue&type=template&id=237a1a7f"
import script from "./TechServiceMechanic.vue?vue&type=script&lang=js"
export * from "./TechServiceMechanic.vue?vue&type=script&lang=js"
import style0 from "./TechServiceMechanic.vue?vue&type=style&index=0&id=237a1a7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports